import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer} from "react-toastify";

export function ToastDisplay() {
  return <ToastContainer theme={"dark"}/>
}